<template>
    <div class="person-box">
        <div>
            <el-row class="person-bg">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>个人中心</el-breadcrumb-item>
                </el-breadcrumb>
                <el-row class="person-infor">
                    <el-row class="person-content" type="flex" justify="space-between">
                        <el-col :span="3">
                            <el-image :src="imageUrl" alt="头像" fit="cover"></el-image>
                            <el-upload ref="imgUpload" :on-success="handleAvatarSuccess" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg" :action="imgUploadUrl" :data="uploadData">
                            </el-upload>
                            <img src="../../assets/images/xiugai.png" class="photo-hover">
                        </el-col>
                        <el-col :span="21">
                            <!-- <el-row class="gr-infor" v-if="vipType == '1' || vipType == '2' || vipType == '3'"> -->
                            <el-row class="gr-infor">
                                <h2>{{personInfor.mobile}}<span v-if="personInfor.sex != '0' && personInfor.sex"><img src="../../assets/images/boy-sex.png" v-if="personInfor.sex == '1'"/><img src="../../assets/images/girl-sex.png" v-if="personInfor.sex == '2'"/></span></h2>
                               <!--  <el-row class="vip-qy">
                                    <img src="../../assets/images/vip-big.png" alt="会员权益" v-if="vipType == '1'">
                                    <img src="../../assets/images/svip-big.png" alt="会员权益" v-if="vipType == '2'">
                                    <img src="../../assets/images/cmcc-vip-big.png" alt="会员权益" v-if="vipType == '3'">
                                    <div>
                                        <el-row class="vip-js" v-if="vipType == '1'">VIP会员</el-row>
                                        <el-row class="vip-js" v-if="vipType == '2'">SVIP会员</el-row>
                                        <el-row class="vip-js" v-if="vipType == '3'">中国移动高考会员</el-row>
                                        <el-row class="vip-date">会员到期时间：{{personInfor.vip_end_time?personInfor.vip_end_time.replace(/\-/g,'/').split(' ')[0]:'-'}}</el-row>
                                    </div>
                                </el-row> -->
                                 <el-row class="vip-qy">
                                    <img v-if="personInfor.user_type_img!='https://gaokao.zmpajx.com/null'" :src="personInfor.user_type_img" alt="会员权益">
                                     <img v-else src="../../assets/images/vip-icon1.png" alt="会员权益">
                                    <div>
                                        <el-row class="vip-js">{{ personInfor.user_type_name }}</el-row>
                                        <el-row class="vip-date">会员到期时间：{{personInfor.vip_end_time?personInfor.vip_end_time.replace(/\-/g,'/').split(' ')[0]:'-'}}</el-row>
                                    </div>
                                </el-row>
                            </el-row>
                            <!-- <el-row class="gr-infor" v-else :class="vipType != 'true'?'gr-infor-diff':''">
                                <h2>{{personInfor.mobile}}<span v-if="personInfor.sex != '0' && personInfor.sex"><img src="../../assets/images/boy-sex.png" v-if="personInfor.sex == '1'"/><img src="../../assets/images/girl-sex.png" v-if="personInfor.sex == '2'"/></span></h2>
                            </el-row> -->
                        </el-col>
                    </el-row>
                </el-row>
            </el-row>
            <el-row class="person-menu">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="个人信息" name="first">
                        <el-row>
                            <el-col :span="6">
                                <el-row class="person-left-menu">
                                    <div class="person-left-item" v-for="(item,index) in leftMenuList" :class="activeLeftIndex==index?'person-left-item-click':''" @click="changeLeftMenuHandler(index)" :key="index">
                                        <img :src="item.src" :alt="item.src" v-if="activeLeftIndex != index">
                                        <img :src="leftMenuActiveList[index].src" :alt="item.src" v-else>
                                        {{item.name}}
                                    </div>
                                </el-row>
                            </el-col>
                            <el-col v-if="!show_loading" :span="18" style="padding-left: 12px;">
                                <el-row class="common-box person-gk-box" v-show="activeLeftIndex == '0'">
                                    <h2>高考信息</h2>
                                    <el-form :model="ruleForm" ref="ruleForm" :rules="rules" :label-width="formLabelWidth" class="gk-form">
                                        <el-form-item label="高考省份：" prop="province">
                                            <el-button v-for="(item,index) in provinceList" :class="index==activeIndex?'active-batch':''" :key="index" @click="changeProvince(index)">{{item.name}}</el-button>
                                            <!-- <el-input v-model="this.options[this.provinceCode].name" autocomplete="off" placeholder="" disabled/> -->
                                        </el-form-item>
                                        <el-form-item label="高考年份：">
                                            <el-select v-model="ruleForm.year" placeholder="请选择高考年份" class="select-year">
                                            <el-option
                                            v-for="item in year_options" 
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                            </el-option>
                                        </el-select>
                                            <!-- <el-input v-model="ruleForm.year" autocomplete="off" placeholder="" disabled/> -->
                                        </el-form-item>
                                        <!-- &&area==='51' -->
                                        <el-form-item label="学校选择：" v-if="activeIndex===1">
                                             <!-- <el-cascader
                                                placeholder="请选择学校"
                                                :options="school_options"
                                                @change="getSchoolHandlers"
                                                filterable></el-cascader> -->
                                            <el-select 
                                            v-model="ruleForm.scl_id" 
                                            filterable placeholder="请输入学校并选择" 
                                            remote                  
  :remote-method="getSchoolHandlers"  >
    <el-option
      v-for="item in school_options"
      :key="item.label"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
                                        </el-form-item>
                                        <!-- &&area==='51' -->
                                        <el-form-item label="年级：" v-if="activeIndex===1">
                                            <el-select v-model="ruleForm.grade_name" placeholder="请选择学段" class="select-year">
                                            <el-option
                                            v-for="item in personal_options" 
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                            </el-option>
                                        </el-select>
                                        </el-form-item>
                                        <!-- <el-form-item label="入学年份：" v-if="activeIndex===1&&area==='51'">
                                            <el-select v-model="ruleForm.enrollment_year" placeholder="请选择入学年份" class="select-year">
                                            <el-option
                                            v-for="item in years_options" 
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                            </el-option>
                                        </el-select>
                                        </el-form-item> -->
                                        <el-form-item v-if="Object.values(subjectList).join('').indexOf('文') != -1" label="科目类别：" prop="local_type_id" class="el-form-item-diff">
                                           <!--  <el-input v-model="ruleForm.subject_name" autocomplete="off" placeholder="" disabled/> -->
                                            <el-button v-for="(item,index) in subjectList" :class="item.local_type==formActiveIndex?'active-batch':''" :key="index.local_type" @click="changeSubject(item.local_type)">{{ item.name }}</el-button>
                                        </el-form-item>
                                        <template v-else>
                                             <el-form-item label="首选科目：" prop="local_type_id">
                                               <!--  <el-input v-model="ruleForm.subject_name" autocomplete="off" placeholder="" disabled/> -->
                                                <el-button v-for="(item,index) in subjectList" :class="item.local_type==formActiveIndex?'active-batch':''" :key="item.local_type" @click="changeSubject(item.local_type)">{{ item.name }}</el-button>
                                            </el-form-item>
                                            <div class="gk-desc">（物理、历史任选1门）</div>
                                            <el-form-item prop="subject_name" label="再选科目：" class="select-course-view">
                                                <el-checkbox-group v-model="ruleForm.subject_name" :max="2">
                                                    <el-checkbox v-for="(item, index) in course_list" :key="index" :label="item">
                                                        {{ item }}
                                                    </el-checkbox>
                                                </el-checkbox-group>
                                            </el-form-item>
                                            <div class="gk-desc">（任意选择2个再选科目）</div>
                                        </template>
                                        <el-form-item label="选择批次：" prop="local_batch_id">
                                            <el-button v-for="(item,index) in batchList" :class="index==formActiveIndex1?'active-batch':''" :key="index" @click="changeActiveIndexHandler1(index,item)">{{item.name}}</el-button>
                                        </el-form-item>
                                        <el-form-item label="高考总分：" prop="score">
                                            <el-input v-model.number="ruleForm.score" autocomplete="off" placeholder="请输入高考总分">
                                                <template slot="append">分</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-form>
                                    <el-button class="infor-btn" @click="teamInfoEditHandler">保存</el-button>  
                                </el-row>
                                <el-row class="common-box person-infor-box" v-show="activeLeftIndex == '1'">
                                    <h2>个人资料</h2>
                                    <el-form :model="ruleFormInfor" ref="ruleFormInfor" :label-width="formLabelWidth1" :rules="rulesInfor">
                                        <el-form-item label="用户名：" prop="mobile" class="el-form-item-diff">
                                            <el-input v-model="ruleFormInfor.user_name" autocomplete="off" placeholder="" disabled>
                                                <!-- <template slot="append">
                                                    <div class="person-infor-update" @click="changeUserName">修改</div>
                                                </template> -->
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="手机号：" prop="mobile" class="el-form-item-diff">
                                            <el-input v-model="ruleFormInfor.mobile" autocomplete="off" placeholder="" disabled/>
                                        </el-form-item>
                                        <el-form-item label="昵称：" prop="nickname" placeholder="请输入昵称">
                                            <el-input v-model="ruleFormInfor.nickname" autocomplete="off" placeholder=""/>
                                        </el-form-item>
                                        <el-form-item label="性别：" prop="sex">
                                            <el-button v-for="(item,index) in sexList" :class="index==formInforActiveIndex1?'active-batch':''" :key="index" @click="changeInforActiveIndexHandler1(index,item)">{{item._sex}}</el-button>
                                        </el-form-item>
                                        <el-form-item label="民族：" prop="nation">
                                            <el-select v-model="ruleFormInfor.nation" placeholder="请选择民族" @change="$forceUpdate()">
                                                <el-option
                                                v-for="item in nationOptions"
                                                :key="item"
                                                :label="item"
                                                :value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="出生日期：" prop="birthdate" class="dialog-birthdate">
                                            <el-date-picker
                                              v-model="ruleFormInfor.birthdate"
                                              type="date"
                                              :clearable="false"
                                              value-format="yyyy-MM-dd"
                                              placeholder="请选择出生日期">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item label="毕业中学：" prop="graduate_school">
                                            <el-input v-model="ruleFormInfor.graduate_school" autocomplete="off" placeholder="请输入毕业中学"/>
                                        </el-form-item>
                                        <!-- <el-form-item label="科类：" prop="subject">
                                            <el-button v-for="(item,index) in subjectList" :class="index==formInforActiveIndex2?'active-batch':''" :key="index" disabled>{{item.name}}</el-button>
                                        </el-form-item> -->
                                        <el-form-item label="应往届：" prop="is_current">
                                            <el-button v-for="(item,index) in currentList" :class="index==formInforActiveIndex3?'active-batch':''" :key="index" @click="changeInforActiveIndexHandler3(index)">{{item}}</el-button>
                                        </el-form-item>
                                        <el-form-item label="身高：" prop="height">
                                            <el-input v-model="ruleFormInfor.height" autocomplete="off" placeholder="请输入身高">
                                                <template slot="append">CM</template>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="体重：" prop="weight">
                                            <el-input v-model="ruleFormInfor.weight" autocomplete="off" placeholder="请输入体重">
                                                <template slot="append">KG</template>
                                            </el-input>
                                        </el-form-item>
                                        <el-row>
                                            <el-col :span="7">
                                                <el-form-item label="裸眼视力：" :prop="'naked_vision_left'" class="dialog-left-right">
                                                    <el-input v-model="ruleFormInfor.naked_vision_left" autocomplete="off" placeholder="请输入">
                                                        <template slot="prepend">左</template>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="7" style="margin-left: -16px;">
                                                <el-form-item label="" :prop="'naked_vision_right'" class="dialog-left-right">
                                                    <el-input v-model="ruleFormInfor.naked_vision_right" autocomplete="off"placeholder="请输入">
                                                        <template slot="prepend">右</template>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="7">
                                                <el-form-item label="矫正视力：" :prop="'corrected_vision_left'" class="dialog-left-right">
                                                    <el-input v-model="ruleFormInfor.corrected_vision_left" autocomplete="off" placeholder="请输入">
                                                        <template slot="prepend">左</template>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="7" style="margin-left: -16px;">
                                                <el-form-item :prop="'corrected_vision_right'" class="dialog-left-right">
                                                    <el-input v-model="ruleFormInfor.corrected_vision_right" autocomplete="off"placeholder="请输入">
                                                        <template slot="prepend">右</template>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="7">
                                                <el-form-item label="眼镜度数：" :prop="'glasses_degree_left'" class="dialog-left-right">
                                                    <el-input v-model="ruleFormInfor.glasses_degree_left" autocomplete="off"placeholder="请输入">
                                                        <template slot="prepend">左</template>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="7" style="margin-left: -16px;">
                                                <el-form-item :prop="'glasses_degree_right'" class="dialog-left-right">
                                                    <el-input v-model="ruleFormInfor.glasses_degree_right" autocomplete="off"placeholder="请输入">
                                                        <template slot="prepend">右</template>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-form>
                                    <el-button class="infor-btn" @click="personInfoEditHandler">保存</el-button>  
                                </el-row>
                                <el-row class="common-box intention-box" v-show="activeLeftIndex == '2'">
                                    <h2>升学意向</h2>
                                    <el-form :model="ruleFormIntention" ref="ruleFormIntention">
                                        <el-form-item v-if="studentList.length > 0" class="stu-view">
                                            <div v-if="studentList[0].stu_id !== ''">
                                                <h3>选择学生</h3>
                                                <el-button v-for="(item,index) in studentList" :class="index==activeStudentIndex?'active-batch':''" :key="index" @click="changeActiveStudent(index)">{{item.stu_info.stu_name}}</el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item prop="">
                                            <h3>1、意向省份。<span>（多选）</span></h3>
                                            <el-checkbox-group v-model="ruleFormIntention.province">
                                                <el-checkbox v-for="(item,index) in provinceOptions" :key="index" :label="item"></el-checkbox>
                                            </el-checkbox-group>
                                        </el-form-item>
                                        <div>
                                            <h3>2、意向城市。<span>（最多选择8个）</span></h3>
                                            <el-row v-if="ruleFormIntention.city.length > 0" class="form-inline">
                                                <el-col :span="12" v-for="(item, index) in ruleFormIntention.city" :key="index">
                                                    <el-form-item>
                                                        <el-input v-model="ruleFormIntention.city[index].join('/')" disabled>
                                                            <i @click="removeOptionsHandler('city',index)" class="el-icon-close" slot="suffix"></i>
                                                        </el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <h4 @click="showIntentionCity">添加意向城市</h4>
                                        </div>
                                        <el-form-item>
                                            <h3>3、院校性质意向。<span>（多选）</span></h3>
                                            <el-checkbox-group v-model="ruleFormIntention.university_nature">
                                                <el-checkbox v-for="(item,index) in natureOptions" :key="index" :label="item"></el-checkbox>
                                            </el-checkbox-group>
                                        </el-form-item>
                                        <el-form-item>
                                            <h3>4、院校属性意向。<span>（多选）</span></h3>
                                            <el-checkbox-group v-model="ruleFormIntention.university_attribute">
                                                <el-checkbox v-for="(item,index) in attributeOptions" :key="index" :label="item"></el-checkbox>
                                            </el-checkbox-group>
                                        </el-form-item>
                                        <el-form-item>
                                            <h3>5、院校类型意向。<span>（多选）</span></h3>
                                            <el-checkbox-group v-model="ruleFormIntention.university_type">
                                                <el-checkbox v-for="(item,index) in typeOptions" :key="index" :label="item"></el-checkbox>
                                            </el-checkbox-group>
                                        </el-form-item>
                                        <div>
                                            <h3>6、心仪高校。<span>（最多选择5个）</span></h3>
                                            <el-row v-if="ruleFormIntention.school.length > 0" class="form-inline">
                                                <el-col :span="12" v-for="(item, index) in ruleFormIntention.school" :key="index">
                                                    <el-form-item>
                                                        <el-input v-model="ruleFormIntention.school[index].scl_name" disabled>
                                                            <i @click="removeOptionsHandler('school',index)" class="el-icon-close" slot="suffix"></i>
                                                        </el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <h4 @click="showIntentionShool">添加心仪高校</h4>
                                        </div>
                                        <el-form-item>
                                            <h3>7、学科类型意向。</h3>
                                            <el-radio-group v-model="ruleFormIntention.subject_type">
                                                <el-radio v-for="(item,index) in subjectOptions" :key="index" :label="item"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                        <el-form-item>
                                            <h3>8、专业门类意向。</h3>
                                            <el-radio-group v-model="ruleFormIntention.special_category">
                                                <el-radio v-for="(item,index) in specialOptions" :key="index" :label="item"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                        <div>
                                            <h3>9、心仪专业。<span>（最多选择5个）</span></h3>
                                            <el-row v-if="ruleFormIntention.special.length > 0" class="form-inline">
                                                <el-col :span="12" v-for="(item, index) in ruleFormIntention.special" :key="index">
                                                    <el-form-item>
                                                        <el-input v-model="ruleFormIntention.special[index].special_name" disabled>
                                                            <i @click="removeOptionsHandler('special',index)" class="el-icon-close" slot="suffix"></i>
                                                        </el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <h4 @click="showIntentionMajor">添加心仪专业</h4>
                                        </div>
                                        <div>
                                            <h3>10、心仪职业。<span>（最多选择5个）</span></h3>
                                            <el-row v-if="ruleFormIntention.job.length > 0" class="form-inline">
                                                <el-col :span="12" v-for="(item, index) in ruleFormIntention.job" :key="index">
                                                    <el-form-item>
                                                        <el-input v-model="ruleFormIntention.job[index].job_name" disabled>
                                                            <i @click="removeOptionsHandler('job',index)" class="el-icon-close" slot="suffix"></i>
                                                        </el-input>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <h4 @click="showIntentionJob">添加心仪职业</h4>
                                        </div>
                                        <el-form-item>
                                            <h3>11、年度学费承受。</h3>
                                            <el-radio-group v-model="ruleFormIntention.tuition">
                                                <el-radio v-for="(item,index) in tuitionOptions" :key="index" :label="item"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-form>
                                    <el-button class="infor-btn" @click="intentionInforEditHandler">保存</el-button>
                                </el-row>
                                <el-row class="common-box person-password-box" v-show="activeLeftIndex == '3'">
                                    <h2>修改密码</h2>
                                    <el-form :model="ruleFormPassword" ref="ruleFormPassword" :rules="rulesPassword" :label-width="formLabelWidth">
                                        <el-form-item label="手机号：" prop="phone">
                                            <el-input v-model="ruleFormPassword.phone" autocomplete="off" placeholder="请输入手机号"></el-input>
                                        </el-form-item>
                                        <el-row type="flex" justify="flex-start">
                                            <el-form-item label="验证码：" class="dialog-input" prop="code">
                                                <el-input v-model="ruleFormPassword.code" autocomplete="off" placeholder="请输入验证码"></el-input>
                                            </el-form-item>
                                            <el-button @click="sendSmsHandler" v-if="showTime" class="register-btn">获取验证码</el-button>
                                            <el-button v-else disabled class="register-btn">{{count}}s后重新获取</el-button>
                                        </el-row>
                                        <el-form-item label="密码：" prop="password">
                                            <el-input v-model="ruleFormPassword.password" autocomplete="off" placeholder="请输入密码" :type="passwordType">
                                            <template slot="append">
                                                <img :src="passwordImg[passwordType]" @click="changeShowPassword">
                                            </template>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="确认密码：" prop="confirmPassword">
                                            <el-input v-model="ruleFormPassword.confirmPassword" autocomplete="off" placeholder="请输入密码" :type="passwordType1">
                                            <template slot="append">
                                                <img :src="passwordImg[passwordType1]" @click="changeShowPassword1">
                                            </template>
                                            </el-input>
                                        </el-form-item>
                                    </el-form>
                                    <el-button class="infor-btn" @click="ForgerForm">保存</el-button>  
                                </el-row>      
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="我的日志" name="second">
                        <el-row>
                            <el-col :span="6">
                                <el-row class="person-left-menu">
                                    <div class="person-left-item" v-for="(item,index) in leftLogMenuList" :class="activeLeftLogIndex==index?'person-left-item-click':''" @click="changeLeftLogMenuHandler(index)" :key="index">
                                        <img :src="item.src" :alt="item.src" v-if="activeLeftLogIndex != index">
                                        <img :src="leftLogMenuActiveList[index].src" :alt="item.src" v-else>
                                        {{item.name}}
                                    </div>
                                </el-row>
                            </el-col>
                            <el-col :span="18" style="padding-left: 12px;">
                                <el-row class="common-box person-gk-box" v-show="activeLeftLogIndex == '0'">
                                    <h2>我的志愿表</h2>
                                    <div v-if="!searchSchoolStatus1" style="margin-top: 20px">
                                        <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="95" width="1000" viewBox="0 0 1000 95" v-for="item in 10" :key="item">
                                            <rect x="0" y="0" width="1100" height="90" />
                                        </ContentLoader>
                                    </div>
                                    <el-row class="zyb-list" v-else-if="showDataStatus=='1'">
                                        <el-row class="zyb-content" type="flex" justify="space-between" v-for="(item,index) in planList" :key="index">
                                            <el-col :span="16">
                                                <div class="zyb-infor"><span class="zyb-tag">{{tag_list[item.plan_type]}}</span>{{item.plan_title}} <span class="lk-infor">{{item.subject}}</span><span class="zyb-span"></span><span>{{item.score}}</span>    <span style="margin-left: 10px;font-size: 12px;padding: 4px;background-color: #ff2929;color: #fff!important;border-radius: 8px;margin-right:10px;cursor: pointer;" @click.stop="handleSpeekSchool(item)">解读</span></div>
                                                <div class="zyb-date">录取总概率：<span>{{item.avg_percent?item.avg_percent:'-'}}%</span>{{item.create_time|dateHandler}}</div>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-button @click="linkDetailEditHandler(item.id,item.plan_title)">编辑</el-button>
                                                <el-button @click="linkDetailHandler(item.id,item.plan_title)">查看</el-button>
                                                <el-button @click="exportDetailHandler(item.id,item.plan_title)">导出PDF</el-button>
                                                <el-button @click="exportDetailHandlerExcel(item.id,item.plan_title)">导出Excel</el-button>
                                                <el-button @click="deletePlanHandler(item.id,index)">删除</el-button>
                                            </el-col>
                                        </el-row>
                                        <el-pagination
                                            background
                                            layout="prev, pager, next, jumper"
                                            :total="totalData" :page-size="10" @current-change="getMyPlanListHandler" :current-page.sync='currentPage'>
                                        </el-pagination>
                                    </el-row>
                                    <el-row  v-else-if="showDataStatus=='0'" class="gx-content">
                                        <div class="no-data-box">
                                            <img src="../../assets/images/null.png" alt="没有数据">
                                            <p>暂无志愿表</p>
                                        </div>
                                    </el-row>
                                </el-row>
                                <el-row class="common-box person-infor-box" v-show="activeLeftLogIndex == '1'">
                                    <h2>我的测评报告</h2>
                                    <div v-if="!searchSchoolStatus2" style="margin-top: 20px">
                                        <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="95" width="1000" viewBox="0 0 1000 95" v-for="item in 10" :key="item">
                                            <rect x="0" y="0" width="1100" height="90" />
                                        </ContentLoader>
                                    </div>
                                    <el-row class="zyb-list" v-else-if="showDataStatus1=='1'">
                                        <el-row class="zyb-content" type="flex" justify="space-between" v-for="(item,index) in testList" :key="index">
                                            <el-col :span="20">
                                                <div class="zyb-infor">{{item.test_name}}</div>
                                                <div class="zyb-date">{{item.create_time|dateHandler}}</div>
                                            </el-col>
                                            <el-col :span="4">
                                                <el-button @click="linkEvaDetailHandler(item)">查看</el-button>
                                                <el-button @click="downloadEvaDetailHandler(item)">下载</el-button>
                                            </el-col>
                                        </el-row>
                                        <!-- <el-pagination
                                            background
                                            layout="prev, pager, next, jumper"
                                            :total="totalData1" :page-size="10" @current-change="getMyTestListHandler" :current-page.sync='currentPage1'>
                                        </el-pagination> -->
                                    </el-row>
                                    <el-row  v-else-if="showDataStatus1=='0'" class="gx-content">
                                        <el-row class="gx-content">
                                            <div class="no-data-box">
                                                <img src="../../assets/images/null.png" alt="没有数据">
                                                <p>暂无测评结果</p>
                                            </div>
                                        </el-row>
                                    </el-row>
                                    <!--  <el-row class="evaluation-detail-drawer" v-if="showResult">
                                        <EvaluationResult
                                            v-if="showResult"
                                            ref="evaluation_result"
                                            :now_date="now_date"
                                            :typeIndex="typeIndex"
                                            :holland_result="holland_result"
                                            @closeResult="closeResult"
                                        ></EvaluationResult>
                                    </el-row> -->
                                </el-row>
                                <el-row class="common-box person-subscribe-box" v-show="activeLeftLogIndex == '2'">
                                    <h2>我的预约</h2>
                                    <div v-if="!searchOrderStatus" style="margin-top: 20px">
                                        <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="105" width="1000" viewBox="0 0 1000 95" v-for="item in 10" :key="item">
                                            <rect x="0" y="0" width="1100" height="100" />
                                        </ContentLoader>
                                    </div>
                                    <el-row class="zyb-list" v-else-if="showOrderDataStatus=='1'">
                                        <el-row class="zyb-content" type="flex" justify="space-between" v-for="(item,index) in myOrderList" :key="index">
                                            <el-col :span="24">
                                                <div class="zyb-infor">{{item.title}}</div>
                                                <div class="zyb-date"><span>预约人：{{item.user_name}}</span><span>预约电话：{{item.mobile}}</span><span v-if="item.special">专业：{{item.special}}</span><span>预约时间：{{item.create_time|dateHandler}}</span></div>
                                            </el-col>
                                        </el-row>
                                        <!-- <el-pagination
                                            background
                                            layout="prev, pager, next"
                                            :total="totalOrderData" :page-size="10" @current-change="getMyOrderListHandler" :current-page.sync='currentOrderPage'>
                                        </el-pagination> -->
                                    </el-row>
                                    <el-row  v-else-if="showOrderDataStatus=='0'" class="gx-content">
                                        <el-row class="gx-content">
                                            <div class="no-data-box">
                                                <img src="../../assets/images/null.png" alt="没有数据">
                                                <p>暂无预约</p>
                                            </div>
                                        </el-row>
                                    </el-row>
                                </el-row> 
                                <el-row class="common-box video-box" v-show="activeLeftLogIndex == '3'">
                                    <h2>我的课堂</h2>
                                    <div v-if="!searchVideoStatus" style="margin-top: 20px">
                                        <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="115" width="1000" viewBox="0 0 1000 115" v-for="item in 10" :key="item">
                                            <rect x="0" y="0" width="1100" height="110" />
                                        </ContentLoader>
                                    </div>
                                    <el-row class="zyb-list" v-else-if="showVideoDataStatus=='1'">
                                        <el-row class="zyb-content" v-for="(item,index) in videoList" :key="index">
                                            <el-col :span="4">
                                                <img :src="item.video_pic">
                                            </el-col>
                                            <el-col :span="20">
                                                <div class="coupon-infor">{{item.video_title}}</div>
                                                <div class="coupon-desc">播放时间{{item.watch_time|dateHandler}}</div>
                                            </el-col>
                                        </el-row>
                                        <!-- <el-pagination
                                            background
                                            layout="prev, pager, next"
                                            :total="totalVideoData" :page-size="10" @current-change="getMyVideoListHandler" :current-page.sync='currentVideoPage'>
                                        </el-pagination> -->
                                    </el-row>
                                    <el-row  v-else-if="showVideoDataStatus=='0'" class="gx-content">
                                        <div class="no-data-box">
                                            <img src="../../assets/images/null.png" alt="没有数据">
                                            <p>暂无课堂</p>
                                        </div>
                                    </el-row>
                                </el-row>       
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="订单列表" name="third">
                        <el-row class="common-box order-box">
                            <h2>订单列表</h2>
                            <div v-if="!searchSchoolStatus4" style="margin-top: 20px">
                                <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="115" width="1000" viewBox="0 0 1000 115" v-for="item in 10" :key="item">
                                    <rect x="0" y="0" width="1100" height="110" />
                                </ContentLoader>
                            </div>
                            <el-row class="zyb-list" v-else-if="showDataStatus3=='1'">
                                <el-row class="zyb-content" type="flex" justify="space-between" v-for="(item,index) in orderList" :key="index">
                                    <el-col :span="2">
                                        <el-image :src="item.product_info.image" alt="志愿卡" fit="contain"></el-image>
                                    </el-col>
                                    <el-col :span="16">
                                        <div class="zyb-infor">{{item.product_info.title.indexOf('荔枝生涯') !== -1 ? website.name ? item.product_info.title.replace('荔枝生涯', website.name) : '荔枝生涯' : item.product_info.title }}</div>
                                        <div class="zyb-fee">¥{{item.product_info.price}}</div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="zyb-date">付款时间：{{item.pay_time?item.pay_time:'未付款'}}</div>
                                        <el-button @click="linkToOrderDetail(item.order_no)">订单详情</el-button>
                                    </el-col>
                                </el-row>
                            </el-row>
                            <el-row  v-else-if="showDataStatus3=='0'" class="gx-content">
                                <div class="no-data-box">
                                    <img src="../../assets/images/null.png" alt="没有数据">
                                    <p>暂无订单</p>
                                </div>
                            </el-row>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="优惠券" name="forth">
                        <el-row class="common-box coupon-box">
                            <h2>优惠券</h2>
                            <div v-if="!searchSchoolStatus3" style="margin-top: 20px">
                                <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="115" width="1000" viewBox="0 0 1000 115" v-for="item in 10" :key="item">
                                    <rect x="0" y="0" width="1100" height="110" />
                                </ContentLoader>
                            </div>
                            <el-row class="zyb-list" v-else-if="showDataStatus2=='1'">
                                <el-row class="zyb-content" v-for="(item,index) in couponList" :key="index">
                                    <el-col :span="3">
                                        <img src="../../assets/images/coupon.png" alt="优惠券">
                                        <el-row class="coupon-box-fee">
                                            <span>￥</span>{{item.coupon_price}}
                                        </el-row>
                                    </el-col>
                                    <el-col :span="19">
                                        <div class="coupon-infor">{{item.name}}</div>
                                        <div class="coupon-desc">使用规则：{{item.coupon_desc?item.coupon_desc:'无'}}</div>
                                        <div class="coupon-desc">使用期限：有效期至{{item.expire_time}}</div>
                                    </el-col>
                                </el-row>
                            </el-row>
                            <el-row  v-else-if="showDataStatus2=='0'" class="gx-content">
                                <div class="no-data-box">
                                    <img src="../../assets/images/null.png" alt="没有数据">
                                    <p>暂无优惠券</p>
                                </div>
                            </el-row>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="已下载资料" name="fifth">
                        <el-row class="common-box download-box">
                            <h2>已下载资料</h2>
                            <div v-if="!searchDownloadStatus" style="margin-top: 20px">
                                <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="95" width="1000" viewBox="0 0 1000 95" v-for="item in 10" :key="item">
                                    <rect x="0" y="0" width="1100" height="92" />
                                </ContentLoader>
                            </div>
                            <el-row class="zyb-list" v-else-if="showDownloadDataStatus=='1'">
                                <el-row class="zyb-content" v-for="(item,index) in downloadList" :key="index">
                                    <el-col :span="2">
                                        <div class="download-subject" :style="{background:bgColorList[item.findIndex],color:colorList[item.findIndex]}" v-if="item.type != '3'">{{item.subject}}</div>
                                            <div class="download-subject download-subject-diff" v-else></div>
                                    </el-col>
                                    <el-col :span="22">
                                        <div class="coupon-infor"><span>{{downLoadType[item.type]}}</span>{{item.name}}</div>
                                        <div class="coupon-desc">下载时间：{{item.create_time|dateHandler}}</div>
                                    </el-col>
                                </el-row>
                                <!-- <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalDownloadData" :page-size="10" @current-change="getMyDownloadListHandler" :current-page.sync='currentDownloadPage'>
                                </el-pagination> -->
                            </el-row>
                            <el-row  v-else-if="showDownloadDataStatus=='0'" class="gx-content">
                                <div class="no-data-box">
                                    <img src="../../assets/images/null.png" alt="没有数据">
                                    <p>暂无资料</p>
                                </div>
                            </el-row>
                        </el-row>   
                    </el-tab-pane>
                </el-tabs>
            </el-row>
        </div>
    <IntentionCity v-if="isIntentionCity" @update="addCity" :cityList="ruleFormIntention.city"></IntentionCity>
    <IntentionSchool v-if="isIntentionSchool" @update="addSchool" :schoolList="ruleFormIntention.school"></IntentionSchool>
    <IntentionMajor v-if="isIntentionMajor" @update="addMajor" :majorList="ruleFormIntention.special"></IntentionMajor>
    <IntentionJob v-if="isIntentionJob" @update="addJob" :jobList="ruleFormIntention.job"></IntentionJob>
    <!-- 虚拟的学校解说 -->
    <el-dialog
      :title="SpeekTitle"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :visible.sync="SpeekcenterDialogVisible"
      width="80%"
      center
      @close="handleClose"
    >
      <div id="sse_data" style="line-height: 24px"></div>
    </el-dialog>
    </div>
</template>

<script>
import { teamInfo, teamInfoEdit, personInfo, getHistoryRecordList, getHistoryRecordDetail, downloadHistoryRecordDetail, personInfoEdit, subscribeList, getIntentionInfor, intentionInforEdit } from '@/api/user'
import { getCouponList, orderList } from '@/api/pay'
import { sendForgetSms,exportDetailHandlerExcel } from "@/api/user"
import { getArea,getProvince,getCity,getAreas,getSchools } from "@/api/home"
import { getNationList, getProvinceList } from "@/utils/person"
import { randomToken } from "@/utils/auth.js"
import { getMyPlanList, deleteMyPlan,getMyPlanDetail  } from '@/api/zhiyuan'
import { getVideoWatchList,downloadList  } from '@/api/video'
import { getToken,getApiSign,
  getBaseURLs,
  nowTime,
  getAesCode, } from '@/utils/auth'
import { ContentLoader } from 'vue-content-loader'
import { mapState } from 'vuex'
import IntentionCity from '@/components/IntentionCity'
import IntentionSchool from '@/components/IntentionSchool'
import IntentionMajor from '@/components/IntentionMajor'
import IntentionJob from '@/components/IntentionJob'
import marked from "marked";
export default {
    components: {
        ContentLoader,
        IntentionCity,
        IntentionSchool,
        IntentionMajor,
        IntentionJob
    },
    data() {
        const validateGrade = (rule, value, callback) => {
			if (value.length === 0) {
                callback(new Error("请输入高考总分"));
			} else {
			    if (!(/(^[1-9]\d*$)/.test(value)) || value > 750) {
				callback(new Error("请输入正确的高考总分"));
			    } else {
				callback();
			    }
			}
		};
		const validateRank = (rule, value, callback) => {
			if (value.length === 0) {
			    callback();
			} else {
			    if (!(/(^[1-9]\d*$)/.test(value))) {
				callback(new Error("请输入正确的排名"));
			    } else {
				callback();
			    }
			}
		};
        const validatePhone = (rule, value, callback) => {
            if (value.length === 0) {
            callback(new Error("请输入手机号"));
            } else {
            if ((/^1[34578]\d{9}$/.test(value))) {
                callback();
            } else {
                callback(new Error("请输入正确的手机号"));
            }
            }
        };
        const validateCode = (rule, value, callback) => {
            if (value === '') {
            callback(new Error('请输入验证码'));
            } else {
            callback();
            }
        };
        const validatePassword = (rule, value, callback) => {
            if (value === '') {
            callback(new Error('请输入密码'));
            } else {
            callback();
            }
        };
        const validateConfirmPassword = (rule, value, callback) => {
            if (value === '') {
            callback(new Error('请输入密码'));
            } else if(value != this.ruleFormPassword.password){
                callback(new Error('密码不一致'));
            } else {
                callback();
            }
        };
        return {
            provinceList: {},
            year_options: [],
            activeName: 'first',
            area:localStorage.getItem("area"),
            mobile: localStorage.getItem("mobile"),
            searchSchoolStatus1: false,
            searchSchoolStatus2: false,
            searchOrderStatus: false,
            searchSchoolStatus3: false,
            searchVideoStatus: false,
            searchDownloadStatus: false,
            searchSchoolStatus4: false,
            gkInfor: {},
            SpeekTitle:'',
            // showClose: true,
            SpeekcenterDialogVisible: false,
            aborController: null,
            showGkStatus: '',
            imageUrl: require('../../assets/images/photo.jpg'),
            uploadData: {
                token: getToken(),
            },
			personInfor: {},
            planList: [],
            myOrderList: [],
            videoList: [],
            downloadList: [],
            showDataStatus: '',
            showDataStatus1: '',
            showOrderDataStatus: '',
            showDataStatus2: '',
            showVideoDataStatus: '',
            Download: '',
            showDataStatus3: '',
            totalData: 0,
            totalOrderData: 0,
            totalVideoData: 0,
            totalDownlaodData: 0,
            imgUploadUrl: '',
            testList: [],
            // showResult: false,
            // now_date: '//-//-// //://:"//',
            // typeIndex: '',
            // holland_result: {},
            currentPage: 1,
            currentOrderPage: 1,
            currentVideoPage: 1,
            currentDownloadPage: 1,
            province: '',
            leftMenuList: [
                {src: require('../../assets/images/gk-icon.png'),name: '高考信息'},
                {src: require('../../assets/images/zl-icon.png'),name:'个人资料'},
                {src: require('../../assets/images/sx-icon.png'),name:'升学意向'},
                {src: require('../../assets/images/mm-icon.png'),name:'修改密码'},
            ],
            leftLogMenuList: [
                {src: require('../../assets/images/my-zy-icon.png'),name: '我的志愿表'},
                {src: require('../../assets/images/my-cp-icon.png'),name:'我的测评报告'},
                {src: require('../../assets/images/my-yy-icon.png'),name:'我的预约'},
                {src: require('../../assets/images/my-kt-icon.png'),name:'我的课堂'},
            ],
            leftMenuActiveList: [
                {src: require('../../assets/images/gk-icon1.png')},
                {src: require('../../assets/images/zl-icon1.png')},
                {src: require('../../assets/images/sx-icon1.png')},
                {src: require('../../assets/images/mm-icon1.png')},
            ],
            leftLogMenuActiveList: [
                {src: require('../../assets/images/my-zy-icon1.png')},
                {src: require('../../assets/images/my-cp-icon1.png')},
                {src: require('../../assets/images/my-yy-icon1.png')},
                {src: require('../../assets/images/my-kt-icon1.png')},
            ],
            activeLeftIndex: 0,
            activeLeftLogIndex: 0,
            time: new Date().getFullYear(),
            subjectList: [],
			batchList: [],
            batchObj: {},
            subjectObj: {},
            sexList: [
                {sex: '1',_sex:'男'},
                {sex: '2',_sex:'女'}
            ],
            course_list: ['化学','生物','政治','地理'],
            show_loading: true,
            ruleForm: {
                year: '',
                province: localStorage.getItem("area"),
                local_type_id: '1',
                local_batch_type: '1',
                score: '',
                section_line: '',
                subject_name: [],
                scl_id:'',
                stage:'',
                enrollment_year:'',
                schoole_name:'',
                grade_name:''
            },
            years_options:[],
            school_options:[],
            personal_options:['初一','初二','初三','高一','高二','高三'],
            ruleFormInfor: {
                sex: '男',
                nickname: '',
                mobile: '',
                nation: '',
                birthdate: '',
                graduate_school: '',
                subject: '文科',
                is_current: 0,
                height: '',
                weight: '',
                naked_vision: { left: '',right: ''},
                corrected_vision: { left: '',right: ''},
                glasses_degree: { left: '',right: ''},
                naked_vision_left: '', 
                naked_vision_right: '',
                corrected_vision_left: '', 
                corrected_vision_right: '',
                glasses_degree_left: '', 
                glasses_degree_right: ''
            },
            options: JSON.parse(sessionStorage.getItem('proInfo')),
            activeIndex: 0,
            formActiveIndex: 0,
            formActiveIndex1: 0,
            formInforActiveIndex1: 0,
            formInforActiveIndex2: 0,
            formInforActiveIndex3: 0,
            formLabelWidth: '105px',
            formLabelWidth1: '80px',
            ruleFormPassword: {
                phone: '',
                code: '',
                password: '',
                confirmPassword: '',
            },
            ruleFormIntention: {
                stu_id: '',
                province: [],
                city: [],
                university_nature: [],
                university_attribute: [],
                university_type: [],
                subject_type: '',
                special_category: '',
                special: [],
                school: [],
                job: [],
                tuition: '',
            },
            passwordImg:{
                "text": require("../../assets/images/show.png"),
                "password": require("../../assets/images/hidden.png"),
            },
            passwordType: 'password',
            passwordType1: 'password',
            passwordStr: false,
            passwordStr1: false,
            smsToken: '',
            count: '',
            timer: null,
            showTime: true,
            uploadUrl: 'https://gaokao.zmpajx.com/',
            // uploadUrl: process.env.VUE_APP_BASE_API + '/',
            nationOptions: getNationList(),
            provinceOptions: getProvinceList(),
            schoolOptions:["北京大学","清华大学","复旦大学","南开大学","中国人民大学"],
            natureOptions: ['不限','公办','民办','中外合作'],
            attributeOptions: ['不限','985','211','部委属','卓越工程师','卓越医生','卓越律师'],
            typeOptions: ['综合','理工','农林','医药','师范','语言','财经','政法','体育','民族','军事','公安'],
            subjectOptions: ['理学','工学','农学','教育学','管理学','经济学','哲学','法学','医学','军事学','历史学','艺术学','文学'],
            specialOptions: ['电子信息类','财经类','农林牧渔类','交通运输类','土木类','医药卫生类','材料与新能源','制造类','轻纺食品类','公共事业类','文化教育类','法律类'],
            tuitionOptions: ['1万元以下','1万至2万','2万至3万','3万至4万','4万至5万','5万至6万'],
            currentList: {1: '应届', 0: '往届'},
            studentList: [],
            activeStudentIndex: 0,
            rulesPassword: {
                phone: [
                    { validator: validatePhone, trigger: 'blur', required: true }
                ],
                code: [
                    { validator: validateCode, trigger: 'blur', required: true }
                ],
                password: [
                    { validator: validatePassword, trigger: 'blur', required: true }
                ],
                confirmPassword: [
                    { validator: validateConfirmPassword, trigger: 'blur', required: true }
                ]
            },
            rulesInfor: {
                // mobile: [
                //     { validator: validatePhone, trigger: 'blur', required: true }
                // ],
            },
            rules: {
                year: [
                    { required: true }
                ],
                subject_name: [
                    { required: true, message: '请选择科目', trigger: 'blur'}, {
                      validator: (rule, value, callback) => {
                        if (value.length !== 2) {
                          callback(new Error('请选择两个科目'));
                        } else {
                          callback();
                        }
                      },
                      trigger: 'blur'
                    }
                ],
                province:  [
                    { required: true }
                ],
                local_type_id:  [
                    { required: true }
                ],
                local_batch_type:  [
                    { required: true }
                ],
                score: [
                    { required: true, trigger: 'blur', validator: validateGrade }
                ],
                section_line: [
                    { type: 'number',trigger: 'blur', validator: validateRank }
                ]
            },
            typeList1: [
                {dic_value: '全部'},
                {dic_value: '语文'},
                {dic_value: '数学'},
                {dic_value: '英语'},
                {dic_value: '物理'},
                {dic_value: '化学'},
                {dic_value: '生物'},
                {dic_value: '政治'},
                {dic_value: '历史'},
                {dic_value: '地理'},
                {dic_value: '文综'},
                {dic_value: '理综'},
            ],
            bgColorList: ['#ffd9c9','#fff0dc','#d4f2da','#def1ff','#dde5ff','#f1e1ff','#ffe1f5','#ffe4ed','#ffe7e7','#e4f0d3','#dee8ff'],
            colorList: ['#ff6524','#ff9324','#0cc740','#24a4ff','#2454ff','#9524ff','#ff24b5','#ff246f','#ff2424','#66b519','#4075e9'],
            downLoadType: {1:'模拟试题',2:'高考真题',3:'高考数据'},
            tag_list: { 0: '志愿填报', 1: '模拟填报', 2: '一键填报' }
        }
    },
	computed: {
        ...mapState({
            isShowGk: state => state.user.isShowGk,
            isSaveUserName: state => state.user.isSaveUserName,
            requestCount: state => state.user.requestCount,
            token: state => state.user.token,
            // vipType: state => state.user.vipType,
            provinceCode: state => state.user.provinceCode,
            isIntentionCity: state => state.user.isIntentionCity,
            isIntentionSchool: state => state.user.isIntentionSchool,
            isIntentionMajor: state => state.user.isIntentionMajor,
            isIntentionJob: state => state.user.isIntentionJob,
            website: state => state.user.website
        }),
	},
	watch: {
	    isShowGk (newVal, oldVal) {
            if((!newVal) && oldVal) {
            this.teamInfoHandler();
            }
	    },
        isSaveUserName(newVal) {
            if(newVal) {
                this.personInfoHandler();
            }
        },
        token (newVal) {
            if(newVal != '') {
                this.$store.commit('user/ADDCOUNT', 0);
                this.personInfoHandler();
                this.intentionInforHandler();
                this.getMyPlanListHandler('1');
                this.getMyTestListHandler();
                this.getMyOrderListHandler('1');
                this.getMyVideoListHandler('1');
                this.getMyDownloadListHandler('1');
                this.getCouponListHandler();
                this.orderListHandler();
                this.imgUploadUrl = process.env.VUE_APP_BASE_API + 'web/other/head_img_upload';
            }
	    },
        provinceCode(newVal) {
            this.$set(this.ruleForm, 'province', this.options[newVal]);
            this.$forceUpdate()
        }
	},
    filters: {
        dateHandler(time) {
            return time.replace(/(\-)/g,'/');
        }
    },
    created() {
        this.show_loading = true
        if(!this.$store.state.user.token) {
            this.searchSchoolStatus1 = true;
            this.searchSchoolStatus2 = true;
            this.searchOrderStatus = true;
            this.searchSchoolStatus3 = true;
            this.searchVideoStatus = true;
            this.searchDownloadStatus = true;
            this.searchSchoolStatus4 = true;
            this.showDataStatus = '0';
            this.showDataStatus1 = '0';
            this.showOrderDataStatus = '0';
            this.showDataStatus2 = '0';
            this.showDataStatus3 = '0';
            this.showVideoDataStatus = '0';
            this.showDownloadDataStatus = '0';
            return
        }
        const param = this.$route.query
        if(Object.keys(param).length !== 0) {
            this.activeName = 'second'
            this.activeLeftLogIndex = 1
        }
        if(new Date().getMonth() > 7) {
            this.time = (new Date().getFullYear()) + 1
        }
        this.$store.commit('user/ADDCOUNT', 0);
         for(let i = 0; i <= 6; i++) {
            this.year_options.push(this.time + i)
        }
        this.personInfoHandler();
        // this.getAreaHandler()
		this.intentionInforHandler();
        this.getMyPlanListHandler('1');
        this.getMyTestListHandler();
        this.getMyOrderListHandler('1');
        this.getMyVideoListHandler('1');
        this.getMyDownloadListHandler('1');
        this.getCouponListHandler();
        this.orderListHandler();
        this.getHandlerSchool()
        this.getYearsYQ()
        this.imgUploadUrl = process.env.VUE_APP_BASE_API + 'web/other/head_img_upload';
       
    },
    methods: {
        getYearsYQ(){
           //加上今年获取以前10年的年份
           let years = []
           for(let i = 0; i <= 10; i++) {
            years.push(this.time - i)
           }
           this.years_options = years
        },
        getSchoolHandlers(val){
            getSchools(val).then(res=>{
                // console.log(res,'成都七中实验学校')
                this.school_options = res.data.data.map(item=>({
                    value: item.scl_id,
                    label: item.name,
                }))
            })
        },
        async getHandlerSchool(){
//              const res = await getProvince()
//    res.data.forEach(item=>{
//     if(item.id === '510000'){
//         this.school_options.push({
//             value: item.id,
//             label: item.name,
//             children: []
//         })
//     }
//   })
  // 2. 城市
//     await Promise.all(
//     this.school_options.map(async (province) => {
//       // 2.1 获取市
//       const cityRes = await getCity(province.value)
//       province.children = cityRes.data.map(ite => ({
//         value: ite.id,
//         label: ite.name,
//         children: []
//       }))

//       // 2.2 循环：获取 区
//       await Promise.all(
//         province.children.map(async (city) => {
//           const areaRes = await getAreas(city.value)
//           city.children = areaRes.data.map(ite => ({
//             value: ite.id,
//             label: ite.name,
//             children: [] // 学校放在这里
//           }))

//           // 2.3 循环：获取 学校（关键！）
//           await Promise.all(
//             city.children.map(async (area) => {
//               // 调用你的学校接口，传3个参数
//               const schoolRes = await getSchools(
//                 province.value,   // 省ID
//                 city.value,       // 市ID
//                 area.value        // 区ID
//               )
//               // 把学校赋值给 children
//               area.children = schoolRes.data.map(ite => ({
//                 value: ite.id,
//                 label: ite.name
//               }))
//             })
//           )
//         })
//       )
//     })
//   )
        // console.log(this.school_options,'this.school_options')
        },
        //  getAreaHandler(flag) {
        //     this.provinceList = JSON.parse(sessionStorage.getItem('proInfo'));
        //     this.activeIndex = localStorage.getItem("area") || Object.keys(this.provinceList)[0];
        //     this.subjectList = this.provinceList[this.activeIndex].local_type_id;
        //     this.formActiveIndex = this.gkInfor.local_type_id || Object.keys(this.subjectList)[0];
        //     this.batchList = batchList;
        // },
          handleClose() {
      if (this.aborController) {
        this.aborController.abort();
        this.aborController = null;
      }
    },
        handleSpeekSchool(item){
            let that = this
            getMyPlanDetail(item.id).then((res) => {
                let plan_info = res.data.plan_info
                this.SpeekTitle = item.plan_title
            const sseElement = document.getElementById("sse_data");
            if (sseElement) {
        sseElement.innerHTML = "";
      }
      let area = localStorage.getItem('area')
            let param = {
                area:area,
                score: item.score,
                local_type_id:item.subject === '物理'?'1':'2',
                section_line:item.section_line,
                plan_info:plan_info
            }
            let encrypted_data_obj = JSON.parse(
        localStorage.getItem("encrypted_data")
      );
      encrypted_data_obj.timestamp = nowTime();
      let encrypted_data = getAesCode(encrypted_data_obj);
      param.token = getToken();
      param.client_id = "74450c23fa139888c2240568a276879d";
      param.encrypted_data = encrypted_data;
      param.sign = getApiSign(param);
      let ret = "";
      for (const it in param) {
        ret +=
          encodeURIComponent(it) + "=" + encodeURIComponent(param[it]) + "&";
      }
      ret = ret.substr(0, ret.length - 1);
      var url = getBaseURLs() + "api/ai/explain_plan" ;
      let sse_data = "";
      this.SpeekcenterDialogVisible = true;
      fallbackToFetch();
      async function fallbackToFetch() {
        if (that.aborController) {
          that.aborController.abort();
          that.aborController = null;
        }
        let reader = null;
        let sse_data = "";
        try {
          that.aborController = new AbortController();
          const { signal } = that.aborController;
          if (signal.aborted) {
            console.log("请求已被中止，无法发起新请求");
            return;
          }
          const response = await fetch(url, {
           method: 'POST',
            signal: signal,
            headers: {
    'Content-Type': 'application/json' 
  },
            body:JSON.stringify(param)
          });
          if (!response.ok) {
            throw new Error(`HTTP错误: ${response.status}`);
          }
          reader = response.body.getReader();
          while (true) {
            if (signal.aborted) {
              throw new Error("请求已被用户中断");
            }
            const { done, value } = await reader.read();
            // this.showClose = done;
            if (done) break;
            const decodedValue = new TextDecoder().decode(value);
            if (decodedValue.indexOf("DONE") === -1) {
              sse_data += decodedValue;
            }

            if (decodedValue.indexOf("message") !== -1) {
              try {
                sse_data = JSON.parse(decodedValue).message;
              } catch (jsonError) {
                console.error("JSON解析失败:", jsonError);
              }
            }
            const sseElement = document.getElementById("sse_data");
            if (sseElement) {
              sseElement.innerHTML = marked(sse_data);
              document.querySelectorAll("hr").forEach((hr) => {
                hr.style.marginTop = "16px";
                hr.style.marginBottom = "16px";
              });
            }
          }
        } catch (error) {
          if (
            error.name === "AbortError" ||
            error.message === "请求已被用户中断"
          ) {
            console.log("用户已中断请求");
          } else if (error.message.startsWith("HTTP错误")) {
            console.error("请求失败:", error.message);
          } else {
            console.error("处理流时发生错误:", error);
          }
        } finally {
          if (reader) {
            try {
              reader.releaseLock();
            } catch (e) {
              console.log("释放流锁时出错:", e);
            }
          }
        }
      }



            })
        },
        async exportDetailHandlerExcel(id,title) {
            let response = await exportDetailHandlerExcel(id);
            console.log(response)
            let blob = new Blob([response], {type: 'application/vnd.ms-excel'});
            let fileName = title + '.xlsx';
            let a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(a.href);
        },
        changeProvince(index) {
            this.activeIndex = index;
            this.subjectList = this.provinceList[index].local_type_id;
            this.formActiveIndex = this.subjectList[0].local_type;
            const batchObj = {}
            const batchList = this.provinceList[index].local_batch_id
             batchList.map(item => {
                batchObj[item.local_batch_id] = item
            })
            const subjectObj = {}
            const subjectList = this.provinceList[this.activeIndex].local_type_id
            subjectList.map(item => {
                subjectObj[item.local_type] = item
            })
            this.subjectObj = subjectObj;
            this.batchObj = batchObj;
            this.batchList = batchList;
            this.ruleForm.subject_name = []
            sessionStorage.setItem('subjectObj', JSON.stringify(subjectObj))
            sessionStorage.setItem('subjectList', JSON.stringify(subjectList))
            sessionStorage.setItem('batchObj', JSON.stringify(batchObj))
            sessionStorage.setItem('batchList', JSON.stringify(batchList))
            this.ruleForm.local_type_id = this.subjectList[0].local_type
            this.ruleForm.local_batch_type = this.batchList[0].local_batch_id
            this.formActiveIndex1 = 0
        },
        changeYear(value, flag) {
            getArea(value).then(res => {
                this.show_loading = false
                sessionStorage.setItem('proInfo', JSON.stringify(res.data))
                this.provinceList = res.data
                this.activeIndex = this.provinceList.findIndex(val => { return val.area === localStorage.getItem("area") });
                this.handleChangeArea(flag)
              })
        },
        handleChangeArea(flag) {
            if(flag) {
                this.activeIndex = this.provinceList.findIndex(val => { return val.area === localStorage.getItem("area") });
            } else {
                this.activeIndex = 0;
            }
            const batchObj = {}
            const batchList = this.provinceList[this.activeIndex].local_batch_id
             batchList.map(item => {
                batchObj[item.local_batch_id] = item
            })
            const subjectObj = {}
            const subjectList = this.provinceList[this.activeIndex].local_type_id
            subjectList.map(item => {
                subjectObj[item.local_type] = item
            })
            sessionStorage.setItem('batchObj', JSON.stringify(batchObj))
            sessionStorage.setItem('batchList', JSON.stringify(batchList))
            sessionStorage.setItem('subjectObj', JSON.stringify(subjectObj))
            sessionStorage.setItem('subjectList', JSON.stringify(subjectList))
            this.subjectList = this.provinceList[this.activeIndex].local_type_id;
            this.batchObj = batchObj
            this.batchList = batchList
            this.subjectObj = subjectObj
            // this.subjectList = subjectList
            if(flag) {
                this.formActiveIndex = this.gkInfor.local_type_id;
                this.formActiveIndex1 = this.batchList.findIndex(val => { return val.local_batch_id == this.gkInfor.local_batch_type})
            } else {
                this.formActiveIndex = this.subjectList[0].local_type;
                this.formActiveIndex1 =  0
                this.ruleForm.province = '41'
                this.ruleForm.subject_name = []
                this.ruleForm.local_type_id = this.formActiveIndex 
                this.ruleForm.local_batch_type = this.batchList[0].local_batch_id
            }
        },
        changeSubject(key) {
            this.formActiveIndex = key;
            this.ruleForm.local_type_id = key;
        },
        linkDetailHandler(id,title) {
            this.showPerson = false;
            this.$router.push({
                path: '/detail',
                query:{
                    id: id,
                    title: title
                }
            })
        },
        linkDetailEditHandler(id,title) {
            this.$router.push({
                path: '/zhiyuan',
                query:{
                    id: id,
                    title: title
                }
            })
        },
        exportDetailHandler(id,title) {
            this.showPerson = false;
            let url = '';
            url = this.$router.resolve({
                path: '/plan_detail',
                query:{
                    id: id,
                    title: title
                }
            })
            window.open(url.href, '_blank');
        },
        teamInfoHandler(flag) {
            teamInfo().then(res => {
                console.log(res,'高考信息')
                const self = this
                if(res.data) {
                    const data = res.data;
                    this.showGkStatus = '1';
                    this.gkInfor = { ...data };
                    if(!flag) {
                        this.changeYear(data.year, true);
                    }
                    setTimeout(() => {
                        const subject = self.subjectObj[data.local_type_id].name;
                        const batch = self.batchObj[data.local_batch_type].name;
                        const subejct_tmp = data.subject_name.split(subject)
                        let subject_name = ''
                        self.gkInfor = Object.assign({}, self.gkInfor, {subject: subject,batch: batch, subject_name: data.subject_name});
                        self.$store.commit('user/EDITGKINFOR',self.gkInfor);
                        self.ruleForm = {...self.gkInfor};
                        self.ruleForm.scl_id = self.gkInfor.school_id?self.gkInfor.school_id.toFixed():'';
                        this.school_options =  [{
          value: self.gkInfor.school_id ? self.gkInfor.school_id.toFixed() : '',
          label: self.gkInfor.school_name || ''
        }]
                        self.ruleForm.stage = self.gkInfor.stage?self.gkInfor.stage.toFixed():'';
                        self.ruleForm.province = localStorage.getItem("area");
                         if(subejct_tmp.length === 2) {
                            const tmp = subejct_tmp[1].split(',')
                            self.ruleForm.subject_name = tmp.slice(1,3)
                        } else {
                            self.ruleForm.subject_name = []
                        }
                        self.formInforActiveIndex2 = self.formActiveIndex;
                        sessionStorage.setItem('subjectObj', JSON.stringify(self.subjectObj))
                        sessionStorage.setItem('batchObj', JSON.stringify(self.batchObj))
                        // this.ruleForm.year = this.personInfor.year;
                        
                    }, 200)
                } else {
                    // this.showGkStatus = '1';
                    // this.ruleForm.local_type_id = this.localTypeId;
                    // this.ruleForm.subject_name = this.subject_name;
                    // this.ruleForm.year = this.gk_year;
                    // this.gkInfor = this.ruleForm;
                    // self.activeIndex = localStorage.getItem("area");
                    // this.changeYear(this.gk_year);
                }
            })
        },
        teamInfoEditHandler() {
			this.$refs.ruleForm.validate((valid) => {
                if (this.ruleForm.province != '41') {
                    let {score, local_type_id, local_batch_type, year,scl_id,grade_name} = this.ruleForm;
                    let subject_name = []
                //     if((this.formActiveIndex == 1 || this.formActiveIndex == 2) && year == '2024') {
                //        subject_name = this.subjectList[this.formActiveIndex]
                //    } else {
                        subject_name = this.subjectObj[this.formActiveIndex].name + ',' + this.ruleForm.subject_name.join(',')
                //    }
                   localStorage.setItem("area", this.options[this.activeIndex].area)
                   if(!this.ruleForm.year) {
                        year = new Date().getFullYear()
                        if(new Date().getMonth() > 7) {
                            year = (new Date().getFullYear()) + 1
                        }
                    }
                    // if(!this.ruleForm.enrollment_year){
                    //     return this.$message({
                    //         message: '请选择高考年份',
                    //         type: 'warning'
                    //     })
                    // }
                    if(!this.ruleForm.grade_name){
                        return this.$message({
                            message: '请选择年级',
                            type: 'warning'
                        })
                    }
                    if(!this.ruleForm.scl_id){
                        return this.$message({
                            message: '请填入选择学校',
                            type: 'warning'
                        })
                    }
                    teamInfoEdit(score, local_type_id, local_batch_type, year, subject_name,scl_id,grade_name).then(res => {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });

                        this.$store.commit('user/CHANGEPROVINCE', this.options[this.activeIndex].area);
                        this.$store.commit('user/CHANGELOCALTYPEID', local_type_id);
                        this.$store.commit('user/CHANGESUBJECT', subject_name);
                        this.$store.commit('user/CHANGEYEAR', year);
                        this.$store.commit('user/CHANGEISREQUIREBIND', false);
                        localStorage.setItem("isEdit","true");
                        this.teamInfoHandler(true)

                    })
                }else{
                    let {score, local_type_id, local_batch_type, year,scl_id,grade_name} = this.ruleForm;
                    let subject_name = []
                //     if((this.formActiveIndex == 1 || this.formActiveIndex == 2) && year == '2024') {
                //        subject_name = this.subjectList[this.formActiveIndex]
                //    } else {
                        subject_name = this.subjectObj[this.formActiveIndex].name + ',' + this.ruleForm.subject_name.join(',')
                //    }
                   localStorage.setItem("area", this.options[this.activeIndex].area)
                   if(!this.ruleForm.year) {
                        year = new Date().getFullYear()
                        if(new Date().getMonth() > 7) {
                            year = (new Date().getFullYear()) + 1
                        }
                    }
                    // if(!this.ruleForm.enrollment_year){
                    //     return this.$message({
                    //         message: '请选择高考年份',
                    //         type: 'warning'
                    //     })
                    // }
                    // if(!this.ruleForm.grade_name){
                    //     return this.$message({
                    //         message: '请选择年级',
                    //         type: 'warning'
                    //     })
                    // }
                    // if(!this.ruleForm.scl_id){
                    //     return this.$message({
                    //         message: '请填入选择学校',
                    //         type: 'warning'
                    //     })
                    // }
                    teamInfoEdit(score, local_type_id, local_batch_type, year, subject_name,scl_id,grade_name).then(res => {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });

                        this.$store.commit('user/CHANGEPROVINCE', this.options[this.activeIndex].area);
                        this.$store.commit('user/CHANGELOCALTYPEID', local_type_id);
                        this.$store.commit('user/CHANGESUBJECT', subject_name);
                        this.$store.commit('user/CHANGEYEAR', year);
                        this.$store.commit('user/CHANGEISREQUIREBIND', false);
                        localStorage.setItem("isEdit","true");
                        this.teamInfoHandler(true)

                    })
                }
			})
		},
        handleAvatarSuccess(res) {
            if(res.data.path) {
                this.$message({
                    type: 'success',
                    message: '修改成功'
                })
				this.imageUrl = this.uploadUrl + res.data.path;
                localStorage.getItem("head_img",this.imageUrl);
                this.$store.commit("user/SAVEHEADIMG",this.imageUrl);
			}
        },
		showGkInforHandler() {
			this.$store.commit('user/SHOWGKINFOR',true);
		},
		personInfoHandler() {
			personInfo().then(res => {
                this.$forceUpdate();
                this.personInfor = res.data;
                this.ruleFormInfor = res.data;
                if(res.data.corrected_vision) {
                    this.ruleFormInfor.corrected_vision_left = res.data.corrected_vision.left
                    this.ruleFormInfor.corrected_vision_right = res.data.corrected_vision.right
                }
                if(res.data.naked_vision) {
                    this.ruleFormInfor.naked_vision_left = res.data.naked_vision.left
                    this.ruleFormInfor.naked_vision_right = res.data.naked_vision.right
                }
                if(res.data.glasses_degree) {
                    this.ruleFormInfor.glasses_degree_left = res.data.glasses_degree.left
                    this.ruleFormInfor.glasses_degree_right = res.data.glasses_degree.right
                }
				this.personInfor.user_type_img = this.uploadUrl + res.data.user_type_img;
                this.formInforActiveIndex1 = res.data.sex - 1;
                this.formInforActiveIndex3 = res.data.is_current || 1;
                this.teamInfoHandler();
                if(res.data.head_img) {
                    this.imageUrl = this.uploadUrl + res.data.head_img;
                    localStorage.getItem("head_img",this.imageUrl);
                    this.$store.commit("user/SAVEHEADIMG",this.imageUrl);
				} else {
				}
			})
		},
        personInfoEditHandler() {
            this.$refs.ruleFormInfor.validate((valid) => {
                if (valid) {
                    const naked_vision = {
                        left: this.ruleFormInfor.naked_vision_left,
                        right: this.ruleFormInfor.naked_vision_right
                    }
                    const corrected_vision = {
                        left: this.ruleFormInfor.corrected_vision_left,
                        right: this.ruleFormInfor.corrected_vision_right
                    }
                    const glasses_degree = {
                        left: this.ruleFormInfor.glasses_degree_left,
                        right: this.ruleFormInfor.glasses_degree_right
                    }
                    this.ruleFormInfor.naked_vision = naked_vision
                    this.ruleFormInfor.corrected_vision = corrected_vision
                    this.ruleFormInfor.glasses_degree = glasses_degree
                    let mobile = this.$store.state.user.mobile;
                    personInfoEdit(mobile, this.ruleFormInfor).then(res => {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        // this.personInfor.sex = sex;
                    })
                }
            })
        },
        intentionInforHandler() {
            getIntentionInfor().then(res => {
                if(res.data.length === 0) {
                    return
                }
                this.studentList = [...res.data]
                res.data.map(item => {
                    for (const key in item) {
                        if (Object.hasOwnProperty.call(item, key)) {
                            if(key === 'university_attribute' || key === 'university_nature'|| key === 'university_type'|| key === 'province' || key === 'city' || key === 'job' || key === 'school' || key === 'special') {
                                if(!item[key]) {
                                    item[key] = []
                                }
                            } else {
                                if(!item[key]) {
                                    item[key] = ''
                                }
                            }
                            
                        }
                    }
                })
                this.ruleFormIntention = res.data[0]
                // if (res.data.hasOwnProperty(key) && res.data[key]) {
                //     this.ruleFormIntention[key] = res.data[key]
                // }
            })
        },
        // 改变学生
        changeActiveStudent(index) {
            this.activeStudentIndex = index
            this.ruleFormIntention = this.studentList[index]
        },
        // 意向城市弹框
        showIntentionCity() {
            this.$store.commit('user/SHOWINTENTIONCITY', true)
        },
        // 添加意向城市
        addCity(data) {
            this.ruleFormIntention.city = [...data]
        },
        // 心仪学校弹框
        showIntentionShool() {
            this.$store.commit('user/SHOWINTENTIONSCHOOL', true)
        },
        // 添加心仪学校
        addSchool(data) {
            this.ruleFormIntention.school = [...data]
        },
        // 心仪专业弹框
        showIntentionMajor() {
            this.$store.commit('user/SHOWINTENTIONMAJOR', true)
        },
        // 添加心仪专业
        addMajor(data) {
            this.ruleFormIntention.special = [...data]
        },
        // 心仪职业弹框
        showIntentionJob() {
            this.$store.commit('user/SHOWINTENTIONJOB', true)
        },
        // 添加心仪职业
        addJob(data) {
            this.ruleFormIntention.job = [...data]
        },
        intentionInforEditHandler() {
            const param = { ...this.ruleFormIntention }
            param.school = this.ruleFormIntention.school.map(item => item.scl_id).join(',')
            param.special = this.ruleFormIntention.special.map(item => item.special_id).join(',')
            param.job = this.ruleFormIntention.job.map(item => item.job_code).join(',')
            intentionInforEdit(param).then(res => {
                this.$message({
                    type: 'success',
                    message: '修改成功'
                })
            })
        },
        // addOptionsHandler(option) {
        //     this.ruleFormIntention[option].push('')
        // },
        removeOptionsHandler(option, index) {
            this.ruleFormIntention[option].splice(index, 1)
        },
        getMyPlanListHandler(page) {
            getMyPlanList(page).then(res => {
                if(res.data.count == 0) {
                    this.showDataStatus = '0';
                    this.searchSchoolStatus1 = true;
                } else {
                    this.showDataStatus = '1';
                    this.searchSchoolStatus1 = true;
                    res.data.data.map(item => {
                        let zyObj = item.plan_desc.split("/");
                        item.subject = zyObj[0];
                        item.score = zyObj[1];
                        return item
                    })
                    this.planList = res.data.data;
                    this.totalData = res.data.count;
                }
            })
        },
        getMyTestListHandler() {
            getHistoryRecordList().then(res => {
                if(res.data.length == 0) {
                    this.showDataStatus1 = '0';
                    this.searchSchoolStatus2 = true;
                } else {
                    const data = res.data;
                    this.searchSchoolStatus2 = true;
                    this.testList = [...data];
                    this.showDataStatus1 = '1';
                }
            })
        },
        deletePlanHandler(id,index) {
            deleteMyPlan(id).then(res => {
                if(res.message == 'success') {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getMyPlanListHandler('1');
                } else {
                    this.$message({
                        message: '删除失败',
                        type: 'error'
                    });
                }
            })
        },
        linkEvaDetailHandler(item) {
            const url = getHistoryRecordDetail(item)
            window.open(url)
        },
        downloadEvaDetailHandler(item) {
            downloadHistoryRecordDetail(item).then(res => {
                window.open(res.data.path)
            })
        },
        // closeResult() {
        //     this.showResult = false;
        // },
        changePassword() {
            this.$store.commit('user/FORGET', true);
        },
        linkToVip() {
            this.$router.push({
                path: '/vip'
            })
        },
        linkToOrderDetail(order_no) {
            this.$router.push({
                name: 'order-detail',
                params: {
                    order_no: order_no
                }
            })
        },
        getCouponListHandler() {
            getCouponList().then(res => {
                if(res.data.length == 0) {
                    this.showDataStatus2 = '0';
                    this.searchSchoolStatus3 = true;
                    return
                }
                this.showDataStatus2 = '1';
                this.searchSchoolStatus3 = true;
                this.couponList = res.data
            })
        },
        orderListHandler() {
            orderList().then(res => {
                if(res.data.length == 0) {
                    this.showDataStatus3 = '0';
                    this.searchSchoolStatus4 = true;
                    return
                }
                this.showDataStatus3 = '1';
                this.searchSchoolStatus4 = true;
                res.data.forEach(elem => {
                    // elem.product_info.image = 'https://gaokao.zmpajx.com/' + elem.product_info.image
                    elem.product_info.image = this.uploadUrl + elem.product_info.image
                });
                this.orderList = res.data
            })
        },
        changeLeftMenuHandler(index) {
            this.activeLeftIndex = index;
        },
        changeLeftLogMenuHandler(index) {
            this.activeLeftLogIndex = index;
        },
        handleClick() {
            // this.$refs.ruleForm.resetFields();
            // this.$refs.ruleFormPassword.resetFields();
            // this.$refs.ruleFormInfor.resetFields();
        },
        sendSmsHandler() {
            this.smsToken = randomToken(32);
            sendForgetSms(this.ruleFormPassword.phone,this.smsToken).then((res) => {
                if(res.status != 200) {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                } else {
                    const TIME_COUNT = 179;
                    if (!this.timer) {
                    this.count = TIME_COUNT;
                    this.showTime = false;
                    this.timer = setInterval(() => {
                        if (this.count > 1 && this.count <= TIME_COUNT) {
                            this.count--;
                        } else {
                            this.showTime = true;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000)
                    }  
                }
            })
        },
        ForgerForm() {
            this.$refs.ruleFormPassword.validate((valid) => {
                if (valid) {
                    this.$store.dispatch('user/FORGETPASSWORD',{
                        mobile: this.ruleFormPassword.phone,
                        sms_code: this.ruleFormPassword.code,
                        sms_token: this.smsToken,
                        new_password: this.ruleFormPassword.password
                    }).then((res) => {
                    }).catch(error => {
                        console.log(error);
                        this.$message.error(error);
                    })
                } else {
                    return false;
                }
            });
        },
        changeShowPassword() {
            this.passwordStr = !this.passwordStr;
            this.passwordType = this.passwordStr ? 'text' : 'password';
        },
        changeShowPassword1() {
            this.passwordStr1 = !this.passwordStr1;
            this.passwordType1 = this.passwordStr1 ? 'text' : 'password';

        },
		changeActiveIndexHandler1(index,item) {
			this.formActiveIndex1 = index;
			this.ruleForm.local_batch_type = item.local_batch_id;
		},
        changeInforActiveIndexHandler1(index,item) {
            this.formInforActiveIndex1 = index;
			this.ruleFormInfor.sex = item.sex;
        },
        changeInforActiveIndexHandler2(index,item) {
            this.formInforActiveIndex2 = index;
            this.ruleFormInfor.subject = item;
        },
        changeInforActiveIndexHandler3(index) {
            this.formInforActiveIndex3 = index;
            this.ruleFormInfor.is_current = index;
        },
         getMyOrderListHandler(page) {
            subscribeList(page).then(res => {
                if(res.data.count == 0) {
                    this.showOrderDataStatus = '0';
                    this.searchOrderStatus = true;
                } else {
                    const data = res.data.list.data;
                    this.searchOrderStatus = true;
                    this.myOrderList = [...data];
                    this.showOrderDataStatus = '1';
                    // this.totalOrderData = res.data.list.total;
                }
            })
        },
        getMyVideoListHandler(page) {
            getVideoWatchList(page).then(res => {
                if(res.data.length == 0) {
                    this.showVideoDataStatus = '0';
                    this.searchVideoStatus = true;
                    return
                }
                this.showVideoDataStatus = '1';
                this.searchVideoStatus = true;
                this.videoList = res.data;
                // this.totalVideoData = res.data.count;
            })
        },
        getMyDownloadListHandler(page) {
            downloadList(page).then(res => {
                if(res.data.length == 0) {
                    this.showDownloadDataStatus = '0';
                    this.searchDownloadStatus = true;
                    return
                }
                this.showDownloadDataStatus = '1';
                this.searchDownloadStatus = true;
                res.data.map((el,index) => {
                    let findIndex = this.typeList1.findIndex(function(item){
                        return item.dic_value == el.subject; 
                    })
                    el.findIndex = findIndex;
                })
                this.downloadList = res.data;
                // this.totalDownloadData = res.data.count;
            })
        },
        changeUserName() {
            this.$store.commit('user/SAVEUSERNAMESUC', false);
            this.$store.commit('user/SHOWSAVEUSERNAME', true);
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
    .person-bg {
        background: url('../../assets/images/person.jpg') no-repeat;
        width: 100%;
        height: 265px;
        background-size: cover;
        background-position: center;
        background-origin: border-box;
        position: relative;
    }
    .person-infor {
        @include gwidth;
    }
    .person-content {
        margin-top: 36px;
        .photo-hover {
            width: 108px;
            height: 108px;
            border-radius: 50%;
            position: absolute;
            top: 0;
        }
        .vip-qy {
            width: 273px;
            height: 56px;
            background: rgba(255,255,255,0.10);
            border-radius: 8px;
            padding: 4px 8px;
            @include gflex;
            img {
                width: 48px;
                height: 48px;
            }
            .vip-js {
                font-size: 16px;
                font-weight: 600;
                color: #ffd597;
                margin-top: 4px;
                padding-left: 6px;
            }
            .vip-date {
                font-size: 12px;
                font-weight: 400;
                color: #ffffff;
                margin-top: 3px;
                padding-left: 6px;
            }
        }
        h2 {
            font-size: 28px;
            font-weight: 600;
            color: #ffffff;
            margin: 0;
            margin-bottom: 16px;
            span {
                display: inline-block;
                width: 24px;
                height: 24px;
                background: #ffffff;
                border-radius: 50%;
                position: absolute;
                top: 5px;
                margin-left: 14px;
                text-align: center;
                img {
                    width: 12px;
                    height: 12px;
                    position: relative;
                    top: -9px;
                }
            }

        }
        .gr-infor-diff {
            margin-top: 40px;
        }
        .gr-infor {
            margin-left: -5px;
        }
    }
    .no-data-box {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        img {
            width: 110px!important;
            height: 110px!important;
        }
        p {
            font-size: 16px;
            text-align: center;
            color: #abaeb3;
        }
    }
    .person-menu {
        @include gwidth;
        margin-top: -53px;
        .person-left-menu {
            width: 290px;
            min-height: 220px;
            background: #ffffff;
            border-radius: 10px;
            padding: 16px 20px;
            box-sizing: border-box;
        }
        .person-left-item {
            line-height: 56px;
            font-size: 18px;
            color: #66605e;
            font-weight: 400;
            padding: 0 16px;
            cursor: pointer;
            img {
                width: 20px;
                height: 20px;
                position: relative;
                top: 3px;
                margin-right: 10px;
            }
        }
        .person-left-item:not(:last-child) {
            margin-bottom: 10px;
        }
        .person-left-item-click {
            background: #fff1eb;
            border-radius: 8px;
            color: $common-color;
        }
    }
    .common-box {
        padding: 24px 24px 32px 24px;
        background: #ffffff;
        border-radius: 10px;
        h2 {
            border-left: 2px solid $common-color;
            border-radius: 1px;
            font-size: 22px;
            font-weight: 600;
            color: #2c2e33;
            padding-left: 8px;
            text-align: left;
            padding-bottom: 0px;
            margin-top: 0;
            margin-bottom: 32px;
        }
        .infor-btn {
            width: 136px;
            height: 52px;
            border: none;
            background: linear-gradient(90deg,#ffa94a, #ff913c);
            border-radius: 8px;
            color: #ffffff;
            font-size: 18px;
            font-weight: 400;
            margin-top: 36px;
        }
    }
    .person-infor-box {
        .person-infor-update {
            line-height: 22px;
            color: $common-color;
            font-size: 16px;
        }

    }
    .person-password-box {
        .register-btn {
            width: 136px;
            height: 52px;
            background: #ffffff;
            border: 1px solid $common-color;
            border-radius: 8px;
            margin-left: 16px;
            color: $common-color;
        }
    }
    .intention-box {
        // h2 {
        //     margin-bottom: 46px;
        // }
        h3 {
            font-size: 16px;
            color: #2c2e33;
            line-height: 22px;
            margin: 0;
            margin-bottom: 14px;
            // margin-top: -14px;
            span {
                color: #fe9f0a;
            }
        }
        h4 {
            font-size: 16px;
            color: #ff6524;
            line-height: 22px;
            font-weight: 400;
            margin-top: 0px;
            cursor: pointer;
            display: inline-block;
        }
    }
    .zyb-content {
        height: 92px;
        background: #f5f7fa;
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 10px;
        .zyb-infor {
            font-size: 20px;
            color: #2c2e33;
            font-weight: 600;
        }
        span {
            font-size: 14px;
            font-weight: 400;
            color: #5e6166!important;
            display: inline-block;
        }
        .lk-infor {
            margin-left: 27px;
        }
        .zyb-span {
            width: 1px;
            height: 14px;
            background: #c4c7cc;
            position: relative;
            top: 2px;
            margin: 0 5px;
        }
        .zyb-tag {
            width: 64px;
            height: 22px;
            background: #fff0e9;
            border-radius: 4px;
            font-size: 12px;
            color: #ff6524!important;
            line-height: 22px;
            text-align: center;
            position: relative;
            top: -3px;
            margin-right: 8px;
        }
        .zyb-date {
            color: #909399;
            font-size: 16px;
            margin-top: 14px;
            span {
                color: $common_color!important;
                margin-right:24px;
            }
        }
        .el-col-8{
            width: 40%;
        }
        .el-col-4, .el-col-8 {
            text-align: right;
            button {
                //width: 44px;
                height: 30px;
                border: 1px solid $common-color;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 400;
                color: $common-color!important;
                text-align: center;
                padding: 0 2px;
                line-height: 30px;
                margin-top: 20px;
                background: none;
            }
            button:hover {
                background: none;
            }
        }
    }
    .zyb-content:hover {
        .zyb-infor {
            color: $common-color;
        }
    }
    .gx-content {
        min-height: 100px;
    }
    .evaluation-detail-drawer {
        background: rgba(0, 0, 0, 0.4);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9999;
        padding: 160px 0;
        overflow-y: scroll;
    }
    .order-box {
        .zyb-content {
            height: 112px;
        }
        .el-image {
            width: 80px;
            height: 80px;
        }
        .zyb-infor {
            font-size: 20px;
            font-weight: 600;
            color: #2c2e33;
            margin-left: 10px;
            margin-top: 4px;
        }
        .zyb-fee {
            font-size: 22px;
            font-weight: 500;
            color: #ee4444;
            margin-top: 27px;
            margin-left: 10px;
        }
        .zyb-date {
            margin-top: 0px;
            font-size: 16px;
        }
        .el-col-6 {
            text-align: right;
            button {
                width: 72px;
                height: 30px;
                border: 1px solid $common-color;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 400;
                color: $common-color!important;
                text-align: center;
                padding: 0;
                line-height: 30px;
                margin-top: 32px;
                background: none;
            }
            button:hover {
                background: none;
            }
        }
    }
    .coupon-box,.video-box,.download-box {
        .zyb-content {
            height: 116px;
            padding: 21px 16px;
        }
        .el-col-19 {
            padding-left: 10px;
        }
        img {
            width: 133px;
            height: 74px;
            position: relative;
        }
        .coupon-box-fee {
            color: #ffffff;
            font-size: 24px;
            // font-weight: 600;
            position: absolute;
            top: 44px;
            left: 20px;
            span {
                font-size: 16px!important; 
                color: #ffffff!important;
            }
        }
        .coupon-infor {
            color: #2c2e33;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 16px;
            span {
                color: #EE4444;
            }
        }
        .coupon-desc {
            color: #909399;
            font-size: 14px;
            font-weight: 400;
            margin-top: 6px;
        }
    }
    .video-box {
        .zyb-content {
            height: 102px;
            padding: 12px 18px;
            box-sizing: border-box;
        }
        img {
            width: 138px;
            height: 78px;
            border-radius: 8px;
        }
        .coupon-infor,.coupon-desc {
            margin-left: 20px;
        }
        .coupon-desc {
            margin-top: 40px;
        }
    }
    .download-box {
        .zyb-content {
            height: 96px;
            padding: 16px;
            box-sizing: border-box;
        }
        .el-col-22 {
            margin-left: -10px;
        }
        .coupon-infor {
            line-height: 25px;
            font-size: 18px;
            margin-top: 3px;
            span {
                display: inline-block;
                width: 64px;
                height: 22px;
                background: #fff0e9;
                border-radius: 4px;
                font-size: 12px;
                font-weight: 400;
                text-align: center;
                color: $common-color!important;
                line-height: 17px;
                margin-right: 16px;
                position: relative;
                top: -2px;
            }
        }
        .download-subject-diff {
            background: url('../../assets/images/download-icon.png') no-repeat!important;
        }
        .download-subject {
            width: 64px;
            height: 64px;
            background: #ffd9c9;
            border-radius: 16px;
            text-align: center;
            line-height: 64px;
            font-size: 20px;
            font-weight: 600;
            color: $common-color;
        }
        .coupon-desc {
            margin-top: 12px;
        }
    }
    .person-subscribe-box {
        span {
            margin-right: 40px;
            color: #909399;
        }
    }
    .form-inline .el-col-12 {
        width: 43%;
    }
    ::v-deep {
        .form-inline .el-input__inner {
            cursor: default;
        }
        .gk-form {
            .el-form-item__label:before {
                display: none;
            }
        }
        .select-course-view {
            .el-checkbox {
                width: 106px!important;
                height: 52px!important;
                background: transparent!important;
                border: 1px solid #e1e4eb!important;
                border-radius: 8px!important;
                position: relative!important;
                z-index: 999!important;
                color: #5e6166!important;
                font-weight: 400!important;
                font-size: 16px!important;
                line-height: 52px;
                text-align: center;
                margin-right: 16px!important;
            }
            .el-checkbox__inner {
                width: 20px;
                height: 20px;
                border: 1px solid #DCDFE6!important;
            }
            .el-checkbox:last-child {
                margin-right: 0!important;
            }
            .el-checkbox__label {
                font-size: 16px;
            }
            .el-checkbox__inner::after {
                top: 3px;
                left: 7px;
                height: 8px;
                width: 4px;
            }
            .el-checkbox.is-checked {
                background: #fff6f3!important;
                border: 1px solid #ff6524!important;
                .el-checkbox__inner {
                    background: #ff6524 !important;
                    border: 1px solid #ff6524 !important;
                }
                
                .el-checkbox__label {
                    color: #ff6524;
                }
            }
        }
    }
    .stu-view {
        ::v-deep button {
            margin: 0 16px 8px 0!important;
        }
    }
    .gk-desc {
        font-size: 16px;
        color: #ff933d;
        margin: -5px 0 20px 100px;
    }
</style>